module.exports = __webpack_public_path__ + "img/solo.8202a91b.png";